import { v4 as uuid } from 'uuid';
import { Form, Button } from 'antd';
import { ZorbaInput } from '../../../../../components/forms';

import './index.scss';

const capitalize = (s) => (s && s[0].toUpperCase() + s.slice(1)) || '';

export default (props) => {
  const {
    params: { organizationName, entityName, additionalEntities },
    validationObj,
  } = props;

  const onChange = (e, key) => {
    const newVal = capitalize(e.target.value);
    props.onChange(key, newVal);
  };

  const handleAddEntity = () => {
    const newEntities = [
      ...(additionalEntities || []),
      { id: uuid(), value: '' },
    ];
    props.onChange('additionalEntities', newEntities);
  };

  const handleEntityChange = (e, idx) => {
    const updated = [...(additionalEntities || [])];
    updated[idx].value = e.target.value;
    props.onChange('additionalEntities', updated);
  };

  return (
    <div className="onboarding-step create">
      <Form.Item
        className="wide"
        help={validationObj.organizationName || ''}
        validateStatus={
          validationObj?.organizationName?.length > 0 ? 'error' : 'success'
        }
        label="What's the name of your company or team?"
      >
        <ZorbaInput
          maxLength={26}
          value={organizationName}
          onChange={(e) => onChange(e, 'organizationName')}
        />
      </Form.Item>

      <Form.Item
        className="wide"
        help={validationObj.entityName || ''}
        validateStatus={
          validationObj?.entityName?.length > 0 ? 'error' : 'success'
        }
        label="What's the name of the entity or LLC you typically buy or hold properties under?"
      >
        <ZorbaInput
          maxLength={26}
          value={entityName}
          onChange={(e) => onChange(e, 'entityName')}
        />
      </Form.Item>

      {additionalEntities.map((entity, idx) => (
        <Form.Item className="wide" key={entity.id} style={{ marginTop: 8 }}>
          <ZorbaInput
            maxLength={26}
            value={entity.value}
            onChange={(e) => handleEntityChange(e, idx)}
          />
        </Form.Item>
      ))}

      <Button type="dashed" onClick={handleAddEntity} style={{ marginTop: 8 }}>
        Add Another Entity
      </Button>
    </div>
  );
};
